import { CmsSlotMetadataComponent } from '../CmsSlotMetadataComponent';
import MagnoliaCmsSlotMetadataComponent from '../magnolia/dynamic-magnolia-cms-slot-metadata.component';

function DefaultCmsPageMetadataComponent(): null {
  return null;
}

const ConfigurableCmsSlotMetadata: CmsSlotMetadataComponent =
  process.env.NEXT_PUBLIC_CMS_METADATA_RENDER === 'magnolia'
    ? MagnoliaCmsSlotMetadataComponent
    : DefaultCmsPageMetadataComponent;

export default ConfigurableCmsSlotMetadata;
